import React, { useState, useContext } from "react";
import PropTypes from "prop-types";
import moment from "moment";

import {
  Grid,
  Paper,
  Typography,
  TextField,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@material-ui/core";

import { RecruitmentContext } from "../../../../../context/states/recruitmentState";
import { AuthContext } from "../../../../../context/states/authState";

import AddIcon from "@material-ui/icons/Add";
import RecentActorsIcon from "@material-ui/icons/RecentActors";

import Loader from "../../../../UI/Loader";

export const Notes = React.memo((props) => {
  const { classes, data, username, isAccessTo } = props;

  const { updateRecruitmentNotesHandler, isRecruitmentNotes } =
    useContext(RecruitmentContext);

  const { permissionKeys } = useContext(AuthContext);

  const [isLoading, setIsLoading] = useState(false);
  const [inputValue, setInputValue] = useState("");

  const canAddNote = permissionKeys.includes("edit-recruitment.notes.add");

  const addRecruitmentNote = async () => {
    if (!canAddNote || !inputValue.trim()) {
      return;
    }

    setIsLoading(true);

    try {
      const payload = {
        id: data._id,
        text: inputValue.trim(),
        updatedBy: username,
      };

      await updateRecruitmentNotesHandler(payload);
      setInputValue("");
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  const notesList = [...(isRecruitmentNotes || [])]
    .sort((a, b) => new Date(b.updated) - new Date(a.updated))
    .map((note) => (
      <ListItem key={note._id}>
        <ListItemIcon>
          <RecentActorsIcon />
        </ListItemIcon>

        <ListItemText
          primary={note.text}
          secondary={`${note.updatedBy} | ${moment(note.updated).format(
            "DD/MM/YYYY, HH:mm",
          )}`}
        />
      </ListItem>
    ));

  return (
    <>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Paper className={classes.paper} variant="outlined">
            <Grid container spacing={2}>
              {/* Notes List */}
              <Grid item xs={12}>
                <Typography
                  variant="subtitle2"
                  style={{ fontWeight: 600 }}
                  color="primary"
                >
                  Recruitment Notes
                </Typography>

                <div style={{ maxHeight: 300, overflow: "auto" }}>
                  <List dense>{notesList}</List>
                </div>
              </Grid>

              {/* Add Note */}
              {!isAccessTo && (
                <Grid item xs={12}>
                  <Grid container spacing={1}>
                    <Grid item xs={11}>
                      <TextField
                        label="Add Note"
                        fullWidth
                        multiline
                        variant="outlined"
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)}
                      />
                    </Grid>

                    <Grid item xs={1}>
                      {canAddNote && (
                        <Button
                          onClick={addRecruitmentNote}
                          disabled={!inputValue.trim()}
                        >
                          <AddIcon />
                          Add
                        </Button>
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              )}
            </Grid>
          </Paper>
        </Grid>
      </Grid>

      <Loader open={isLoading} handleClose={() => setIsLoading(false)} />
    </>
  );
});

Notes.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  handleClose: PropTypes.func,
};
